<div class="sku-header" *ngIf="sku">
  <div class="sku-header_image">
    <img class="sku-header_image-inner" [src]="sku.image" alt="" />
  </div>
  <div class="sku-header_title" [matTooltip]="sku.title" [matTooltipPosition]="'above'">{{ sku.title }}</div>
  <!-- <div class="sku-header_expand-link">
    <i class="fal fa-external-link-square"></i>
  </div> -->
  <div class="sku-header_chips">
    <app-sku-chip
      [name]="'SKU'"
      [value]="sku.sku"
      [link]="skuLink"
    ></app-sku-chip>
    <app-sku-chip
      [name]="'ASIN'"
      [value]="sku.asin"
      [link]="asinLink"
    ></app-sku-chip>

    <app-sku-chip
      *ngIf="sku.fnSku"
      [name]="'FNSKU'"
      [value]="sku.fnSku"
    ></app-sku-chip>
  </div>
</div>
<div class="panel-detail" *ngIf="isPriceyardSmallSidePanel && !isModel">
  <span><span class="label">Min</span><br>{{ this.setPriceHeader?.minPrice | currency }}</span>
  <span><span class="label">Max</span><br>{{ this.setPriceHeader?.maxPrice | currency }}</span>
  <span><span class="label">Default</span><br>{{ this.setPriceHeader?.defaultPrice | currency }}</span>
  <span><span class="label">Pricing Mode</span><br> {{this.sku?.repricingModel?.name}} <span class="repricing_icon" 
  [ngClass]="this.sku?.pricingOn ? 'repricing_icon--on' : 'repricing_icon--off'"></span></span>
</div>
